/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from "@atproto/lex";
import * as EmbedImages from "../embed/images.defs.js";
import * as EmbedVideo from "../embed/video.defs.js";
import * as EmbedGallery from "../embed/gallery.defs.js";
import * as EmbedExternal from "../embed/external.defs.js";
import * as EmbedRecord from "../embed/record.defs.js";
import * as EmbedRecordWithMedia from "../embed/recordWithMedia.defs.js";
import * as ActorDefs from "../actor/defs.defs.js";
import * as LabelDefs from "../../../com/atproto/label/defs.defs.js";
import * as RichtextFacet from "../richtext/facet.defs.js";
import * as GraphDefs from "../graph/defs.defs.js";

const $nsid = "app.bsky.feed.defs";

export { $nsid };

type PostView = { $type?: "app.bsky.feed.defs#postView";"cid":l.CidString;"uri":l.AtUriString;

  /**
   * Debug information for internal development
   */
  "debug"?:l.LexMap;"embed"?:l.$Typed<EmbedImages.View> | l.$Typed<EmbedVideo.View> | l.$Typed<EmbedGallery.View> | l.$Typed<EmbedExternal.View> | l.$Typed<EmbedRecord.View> | l.$Typed<EmbedRecordWithMedia.View> | l.Unknown$TypedObject;"author":ActorDefs.ProfileViewBasic;"labels"?:(LabelDefs.Label)[];"record":l.LexMap;"viewer"?:ViewerState;"indexedAt":l.DatetimeString;"likeCount"?:number;"quoteCount"?:number;"replyCount"?:number;"threadgate"?:ThreadgateView;"repostCount"?:number;"bookmarkCount"?:number };

export type { PostView };

const postView = /*#__PURE__*/ l.typedObject<PostView>($nsid, "postView", /*#__PURE__*/ l.object({"cid":/*#__PURE__*/ l.string({"format":"cid"}),"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"debug":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap()),"embed":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<EmbedImages.View>((() => EmbedImages.view) as any),/*#__PURE__*/ l.typedRef<EmbedVideo.View>((() => EmbedVideo.view) as any),/*#__PURE__*/ l.typedRef<EmbedGallery.View>((() => EmbedGallery.view) as any),/*#__PURE__*/ l.typedRef<EmbedExternal.View>((() => EmbedExternal.view) as any),/*#__PURE__*/ l.typedRef<EmbedRecord.View>((() => EmbedRecord.view) as any),/*#__PURE__*/ l.typedRef<EmbedRecordWithMedia.View>((() => EmbedRecordWithMedia.view) as any)], false)),"author":/*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>((() => ActorDefs.profileViewBasic) as any),"labels":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any), )),"record":/*#__PURE__*/ l.lexMap(),"viewer":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ViewerState>((() => viewerState) as any)),"indexedAt":/*#__PURE__*/ l.string({"format":"datetime"}),"likeCount":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"quoteCount":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"replyCount":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"threadgate":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ThreadgateView>((() => threadgateView) as any)),"repostCount":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),"bookmarkCount":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer())}));

export { postView };

type ReplyRef = { $type?: "app.bsky.feed.defs#replyRef";"root":l.$Typed<PostView> | l.$Typed<NotFoundPost> | l.$Typed<BlockedPost> | l.Unknown$TypedObject;"parent":l.$Typed<PostView> | l.$Typed<NotFoundPost> | l.$Typed<BlockedPost> | l.Unknown$TypedObject;

  /**
   * When parent is a reply to another post, this is the author of that post.
   */
  "grandparentAuthor"?:ActorDefs.ProfileViewBasic };

export type { ReplyRef };

const replyRef = /*#__PURE__*/ l.typedObject<ReplyRef>($nsid, "replyRef", /*#__PURE__*/ l.object({"root":/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<PostView>((() => postView) as any),/*#__PURE__*/ l.typedRef<NotFoundPost>((() => notFoundPost) as any),/*#__PURE__*/ l.typedRef<BlockedPost>((() => blockedPost) as any)], false),"parent":/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<PostView>((() => postView) as any),/*#__PURE__*/ l.typedRef<NotFoundPost>((() => notFoundPost) as any),/*#__PURE__*/ l.typedRef<BlockedPost>((() => blockedPost) as any)], false),"grandparentAuthor":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>((() => ActorDefs.profileViewBasic) as any))}));

export { replyRef };

type ReasonPin = { $type?: "app.bsky.feed.defs#reasonPin" };

export type { ReasonPin };

const reasonPin = /*#__PURE__*/ l.typedObject<ReasonPin>($nsid, "reasonPin", /*#__PURE__*/ l.object({}));

export { reasonPin };

type BlockedPost = { $type?: "app.bsky.feed.defs#blockedPost";"uri":l.AtUriString;"author":BlockedAuthor;"blocked":true };

export type { BlockedPost };

const blockedPost = /*#__PURE__*/ l.typedObject<BlockedPost>($nsid, "blockedPost", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"author":/*#__PURE__*/ l.ref<BlockedAuthor>((() => blockedAuthor) as any),"blocked":/*#__PURE__*/ l.literal(true)}));

export { blockedPost };

type Interaction = { $type?: "app.bsky.feed.defs#interaction";"item"?:l.AtUriString;"event"?:"app.bsky.feed.defs#requestLess" | "app.bsky.feed.defs#requestMore" | "app.bsky.feed.defs#clickthroughItem" | "app.bsky.feed.defs#clickthroughAuthor" | "app.bsky.feed.defs#clickthroughReposter" | "app.bsky.feed.defs#clickthroughEmbed" | "app.bsky.feed.defs#interactionSeen" | "app.bsky.feed.defs#interactionLike" | "app.bsky.feed.defs#interactionRepost" | "app.bsky.feed.defs#interactionReply" | "app.bsky.feed.defs#interactionQuote" | "app.bsky.feed.defs#interactionShare" | l.UnknownString;

  /**
   * Unique identifier per request that may be passed back alongside interactions.
   */
  "reqId"?:string;

  /**
   * Context on a feed item that was originally supplied by the feed generator on getFeedSkeleton.
   */
  "feedContext"?:string };

export type { Interaction };

const interaction = /*#__PURE__*/ l.typedObject<Interaction>($nsid, "interaction", /*#__PURE__*/ l.object({"item":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"at-uri"})),"event":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string<{"knownValues":["app.bsky.feed.defs#requestLess","app.bsky.feed.defs#requestMore","app.bsky.feed.defs#clickthroughItem","app.bsky.feed.defs#clickthroughAuthor","app.bsky.feed.defs#clickthroughReposter","app.bsky.feed.defs#clickthroughEmbed","app.bsky.feed.defs#interactionSeen","app.bsky.feed.defs#interactionLike","app.bsky.feed.defs#interactionRepost","app.bsky.feed.defs#interactionReply","app.bsky.feed.defs#interactionQuote","app.bsky.feed.defs#interactionShare"]}>()),"reqId":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":100})),"feedContext":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":2000}))}));

export { interaction };

/** Request that less content like the given feed item be shown in the feed */
type RequestLess = "app.bsky.feed.defs#requestLess";

export type { RequestLess };

/** Request that less content like the given feed item be shown in the feed */
const requestLess = /*#__PURE__*/ l.token($nsid, "requestLess");

export { requestLess };

/** Request that more content like the given feed item be shown in the feed */
type RequestMore = "app.bsky.feed.defs#requestMore";

export type { RequestMore };

/** Request that more content like the given feed item be shown in the feed */
const requestMore = /*#__PURE__*/ l.token($nsid, "requestMore");

export { requestMore };

/** Metadata about the requesting account's relationship with the subject content. Only has meaningful content for authed requests. */
type ViewerState = { $type?: "app.bsky.feed.defs#viewerState";"like"?:l.AtUriString;"pinned"?:boolean;"repost"?:l.AtUriString;"bookmarked"?:boolean;"threadMuted"?:boolean;"replyDisabled"?:boolean;"embeddingDisabled"?:boolean };

export type { ViewerState };

/** Metadata about the requesting account's relationship with the subject content. Only has meaningful content for authed requests. */
const viewerState = /*#__PURE__*/ l.typedObject<ViewerState>($nsid, "viewerState", /*#__PURE__*/ l.object({"like":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"at-uri"})),"pinned":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"repost":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"at-uri"})),"bookmarked":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"threadMuted":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"replyDisabled":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean()),"embeddingDisabled":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean())}));

export { viewerState };

type FeedViewPost = { $type?: "app.bsky.feed.defs#feedViewPost";"post":PostView;"reply"?:ReplyRef;

  /**
   * Unique identifier per request that may be passed back alongside interactions.
   */
  "reqId"?:string;"reason"?:l.$Typed<ReasonRepost> | l.$Typed<ReasonPin> | l.Unknown$TypedObject;

  /**
   * Context provided by feed generator that may be passed back alongside interactions.
   */
  "feedContext"?:string };

export type { FeedViewPost };

const feedViewPost = /*#__PURE__*/ l.typedObject<FeedViewPost>($nsid, "feedViewPost", /*#__PURE__*/ l.object({"post":/*#__PURE__*/ l.ref<PostView>((() => postView) as any),"reply":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ReplyRef>((() => replyRef) as any)),"reqId":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":100})),"reason":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<ReasonRepost>((() => reasonRepost) as any),/*#__PURE__*/ l.typedRef<ReasonPin>((() => reasonPin) as any)], false)),"feedContext":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":2000}))}));

export { feedViewPost };

type NotFoundPost = { $type?: "app.bsky.feed.defs#notFoundPost";"uri":l.AtUriString;"notFound":true };

export type { NotFoundPost };

const notFoundPost = /*#__PURE__*/ l.typedObject<NotFoundPost>($nsid, "notFoundPost", /*#__PURE__*/ l.object({"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"notFound":/*#__PURE__*/ l.literal(true)}));

export { notFoundPost };

type ReasonRepost = { $type?: "app.bsky.feed.defs#reasonRepost";"by":ActorDefs.ProfileViewBasic;"cid"?:l.CidString;"uri"?:l.AtUriString;"indexedAt":l.DatetimeString };

export type { ReasonRepost };

const reasonRepost = /*#__PURE__*/ l.typedObject<ReasonRepost>($nsid, "reasonRepost", /*#__PURE__*/ l.object({"by":/*#__PURE__*/ l.ref<ActorDefs.ProfileViewBasic>((() => ActorDefs.profileViewBasic) as any),"cid":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"cid"})),"uri":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"at-uri"})),"indexedAt":/*#__PURE__*/ l.string({"format":"datetime"})}));

export { reasonRepost };

type BlockedAuthor = { $type?: "app.bsky.feed.defs#blockedAuthor";"did":l.DidString;"viewer"?:ActorDefs.ViewerState };

export type { BlockedAuthor };

const blockedAuthor = /*#__PURE__*/ l.typedObject<BlockedAuthor>($nsid, "blockedAuthor", /*#__PURE__*/ l.object({"did":/*#__PURE__*/ l.string({"format":"did"}),"viewer":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ActorDefs.ViewerState>((() => ActorDefs.viewerState) as any))}));

export { blockedAuthor };

type GeneratorView = { $type?: "app.bsky.feed.defs#generatorView";"cid":l.CidString;"did":l.DidString;"uri":l.AtUriString;"avatar"?:l.UriString;"labels"?:(LabelDefs.Label)[];"viewer"?:GeneratorViewerState;"creator":ActorDefs.ProfileView;"indexedAt":l.DatetimeString;"likeCount"?:number;"contentMode"?:"app.bsky.feed.defs#contentModeUnspecified" | "app.bsky.feed.defs#contentModeVideo" | l.UnknownString;"description"?:string;"displayName":string;"descriptionFacets"?:(RichtextFacet.Main)[];"acceptsInteractions"?:boolean };

export type { GeneratorView };

const generatorView = /*#__PURE__*/ l.typedObject<GeneratorView>($nsid, "generatorView", /*#__PURE__*/ l.object({"cid":/*#__PURE__*/ l.string({"format":"cid"}),"did":/*#__PURE__*/ l.string({"format":"did"}),"uri":/*#__PURE__*/ l.string({"format":"at-uri"}),"avatar":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"uri"})),"labels":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<LabelDefs.Label>((() => LabelDefs.label) as any), )),"viewer":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<GeneratorViewerState>((() => generatorViewerState) as any)),"creator":/*#__PURE__*/ l.ref<ActorDefs.ProfileView>((() => ActorDefs.profileView) as any),"indexedAt":/*#__PURE__*/ l.string({"format":"datetime"}),"likeCount":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer({"minimum":0})),"contentMode":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string<{"knownValues":["app.bsky.feed.defs#contentModeUnspecified","app.bsky.feed.defs#contentModeVideo"]}>()),"description":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":3000,"maxGraphemes":300})),"displayName":/*#__PURE__*/ l.string(),"descriptionFacets":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<RichtextFacet.Main>((() => RichtextFacet.main) as any), )),"acceptsInteractions":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.boolean())}));

export { generatorView };

/** Metadata about this post within the context of the thread it is in. */
type ThreadContext = { $type?: "app.bsky.feed.defs#threadContext";"rootAuthorLike"?:l.AtUriString };

export type { ThreadContext };

/** Metadata about this post within the context of the thread it is in. */
const threadContext = /*#__PURE__*/ l.typedObject<ThreadContext>($nsid, "threadContext", /*#__PURE__*/ l.object({"rootAuthorLike":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"at-uri"}))}));

export { threadContext };

type ThreadViewPost = { $type?: "app.bsky.feed.defs#threadViewPost";"post":PostView;"parent"?:l.$Typed<ThreadViewPost> | l.$Typed<NotFoundPost> | l.$Typed<BlockedPost> | l.Unknown$TypedObject;"replies"?:(l.$Typed<ThreadViewPost> | l.$Typed<NotFoundPost> | l.$Typed<BlockedPost> | l.Unknown$TypedObject)[];"threadContext"?:ThreadContext };

export type { ThreadViewPost };

const threadViewPost = /*#__PURE__*/ l.typedObject<ThreadViewPost>($nsid, "threadViewPost", /*#__PURE__*/ l.object({"post":/*#__PURE__*/ l.ref<PostView>((() => postView) as any),"parent":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<ThreadViewPost>((() => threadViewPost) as any),/*#__PURE__*/ l.typedRef<NotFoundPost>((() => notFoundPost) as any),/*#__PURE__*/ l.typedRef<BlockedPost>((() => blockedPost) as any)], false)),"replies":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<ThreadViewPost>((() => threadViewPost) as any),/*#__PURE__*/ l.typedRef<NotFoundPost>((() => notFoundPost) as any),/*#__PURE__*/ l.typedRef<BlockedPost>((() => blockedPost) as any)], false), )),"threadContext":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.ref<ThreadContext>((() => threadContext) as any))}));

export { threadViewPost };

type ThreadgateView = { $type?: "app.bsky.feed.defs#threadgateView";"cid"?:l.CidString;"uri"?:l.AtUriString;"lists"?:(GraphDefs.ListViewBasic)[];"record"?:l.LexMap };

export type { ThreadgateView };

const threadgateView = /*#__PURE__*/ l.typedObject<ThreadgateView>($nsid, "threadgateView", /*#__PURE__*/ l.object({"cid":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"cid"})),"uri":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"at-uri"})),"lists":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.array(/*#__PURE__*/ l.ref<GraphDefs.ListViewBasic>((() => GraphDefs.listViewBasic) as any), )),"record":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.lexMap())}));

export { threadgateView };

/** User liked the feed item */
type InteractionLike = "app.bsky.feed.defs#interactionLike";

export type { InteractionLike };

/** User liked the feed item */
const interactionLike = /*#__PURE__*/ l.token($nsid, "interactionLike");

export { interactionLike };

/** Feed item was seen by user */
type InteractionSeen = "app.bsky.feed.defs#interactionSeen";

export type { InteractionSeen };

/** Feed item was seen by user */
const interactionSeen = /*#__PURE__*/ l.token($nsid, "interactionSeen");

export { interactionSeen };

/** User clicked through to the feed item */
type ClickthroughItem = "app.bsky.feed.defs#clickthroughItem";

export type { ClickthroughItem };

/** User clicked through to the feed item */
const clickthroughItem = /*#__PURE__*/ l.token($nsid, "clickthroughItem");

export { clickthroughItem };

/** Declares the feed generator returns posts containing app.bsky.embed.video embeds. */
type ContentModeVideo = "app.bsky.feed.defs#contentModeVideo";

export type { ContentModeVideo };

/** Declares the feed generator returns posts containing app.bsky.embed.video embeds. */
const contentModeVideo = /*#__PURE__*/ l.token($nsid, "contentModeVideo");

export { contentModeVideo };

/** User quoted the feed item */
type InteractionQuote = "app.bsky.feed.defs#interactionQuote";

export type { InteractionQuote };

/** User quoted the feed item */
const interactionQuote = /*#__PURE__*/ l.token($nsid, "interactionQuote");

export { interactionQuote };

/** User replied to the feed item */
type InteractionReply = "app.bsky.feed.defs#interactionReply";

export type { InteractionReply };

/** User replied to the feed item */
const interactionReply = /*#__PURE__*/ l.token($nsid, "interactionReply");

export { interactionReply };

/** User shared the feed item */
type InteractionShare = "app.bsky.feed.defs#interactionShare";

export type { InteractionShare };

/** User shared the feed item */
const interactionShare = /*#__PURE__*/ l.token($nsid, "interactionShare");

export { interactionShare };

type SkeletonFeedPost = { $type?: "app.bsky.feed.defs#skeletonFeedPost";"post":l.AtUriString;"reason"?:l.$Typed<SkeletonReasonRepost> | l.$Typed<SkeletonReasonPin> | l.Unknown$TypedObject;

  /**
   * Context that will be passed through to client and may be passed to feed generator back alongside interactions.
   */
  "feedContext"?:string };

export type { SkeletonFeedPost };

const skeletonFeedPost = /*#__PURE__*/ l.typedObject<SkeletonFeedPost>($nsid, "skeletonFeedPost", /*#__PURE__*/ l.object({"post":/*#__PURE__*/ l.string({"format":"at-uri"}),"reason":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.typedUnion([/*#__PURE__*/ l.typedRef<SkeletonReasonRepost>((() => skeletonReasonRepost) as any),/*#__PURE__*/ l.typedRef<SkeletonReasonPin>((() => skeletonReasonPin) as any)], false)),"feedContext":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"maxLength":2000}))}));

export { skeletonFeedPost };

/** User clicked through to the embedded content of the feed item */
type ClickthroughEmbed = "app.bsky.feed.defs#clickthroughEmbed";

export type { ClickthroughEmbed };

/** User clicked through to the embedded content of the feed item */
const clickthroughEmbed = /*#__PURE__*/ l.token($nsid, "clickthroughEmbed");

export { clickthroughEmbed };

/** User reposted the feed item */
type InteractionRepost = "app.bsky.feed.defs#interactionRepost";

export type { InteractionRepost };

/** User reposted the feed item */
const interactionRepost = /*#__PURE__*/ l.token($nsid, "interactionRepost");

export { interactionRepost };

type SkeletonReasonPin = { $type?: "app.bsky.feed.defs#skeletonReasonPin" };

export type { SkeletonReasonPin };

const skeletonReasonPin = /*#__PURE__*/ l.typedObject<SkeletonReasonPin>($nsid, "skeletonReasonPin", /*#__PURE__*/ l.object({}));

export { skeletonReasonPin };

/** User clicked through to the author of the feed item */
type ClickthroughAuthor = "app.bsky.feed.defs#clickthroughAuthor";

export type { ClickthroughAuthor };

/** User clicked through to the author of the feed item */
const clickthroughAuthor = /*#__PURE__*/ l.token($nsid, "clickthroughAuthor");

export { clickthroughAuthor };

/** User clicked through to the reposter of the feed item */
type ClickthroughReposter = "app.bsky.feed.defs#clickthroughReposter";

export type { ClickthroughReposter };

/** User clicked through to the reposter of the feed item */
const clickthroughReposter = /*#__PURE__*/ l.token($nsid, "clickthroughReposter");

export { clickthroughReposter };

type GeneratorViewerState = { $type?: "app.bsky.feed.defs#generatorViewerState";"like"?:l.AtUriString };

export type { GeneratorViewerState };

const generatorViewerState = /*#__PURE__*/ l.typedObject<GeneratorViewerState>($nsid, "generatorViewerState", /*#__PURE__*/ l.object({"like":/*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({"format":"at-uri"}))}));

export { generatorViewerState };

type SkeletonReasonRepost = { $type?: "app.bsky.feed.defs#skeletonReasonRepost";"repost":l.AtUriString };

export type { SkeletonReasonRepost };

const skeletonReasonRepost = /*#__PURE__*/ l.typedObject<SkeletonReasonRepost>($nsid, "skeletonReasonRepost", /*#__PURE__*/ l.object({"repost":/*#__PURE__*/ l.string({"format":"at-uri"})}));

export { skeletonReasonRepost };

/** Declares the feed generator returns any types of posts. */
type ContentModeUnspecified = "app.bsky.feed.defs#contentModeUnspecified";

export type { ContentModeUnspecified };

/** Declares the feed generator returns any types of posts. */
const contentModeUnspecified = /*#__PURE__*/ l.token($nsid, "contentModeUnspecified");

export { contentModeUnspecified };
